// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2623":"3d8845e2","9980":"0b427570"}[chunkId] + ".chunk.css";
};